import * as React from 'react';
import { Button, CssVarsProvider, Input, Sheet, Stack, Typography } from "@mui/joy"
import { defineToken, triggerLogar, updateDadosLogin } from "./AuthenticationSlice"
import { useDispatch, useSelector } from "react-redux"
import { Navigate } from "react-router-dom"


function Login() {

    var login = useSelector((state) => state.auth.login)
    var logando = login.logando
    var erro = login.erro
    var email = login.email
    var senha = login.senha
    var estaAutenticado = useSelector((state) => state.auth.estaAutenticado)

    var dispatch = useDispatch()
    var update = (e) => {
        dispatch(updateDadosLogin({
            campo: e.target.name,
            valor: e.target.value
        }));
     }
    var logar = () => {
        dispatch(triggerLogar())
    }

    var verificaSeTokenExiste = () => {
        var token = localStorage.getItem("token")
        if (token !== null && typeof (token) !== "undefined" && token.trim() !== "") {
            dispatch(defineToken(token))
        }
    }

    React.useEffect(() => {
        verificaSeTokenExiste();
    }, []);

    return estaAutenticado ? <Navigate to="/todos" /> : <CssVarsProvider>
        <main>
            {/* <ModeToggle /> */}
            <Sheet
                sx={{
                    width: 300,
                    mx: 'auto', // margin left & right
                    my: 4, // margin top & botom
                    py: 3, // padding top & bottom
                    px: 2, // padding left & right
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    borderRadius: 'sm',
                    background: "#fff",
                    boxShadow: 'md',
                }}
                variant="outlined"
            >
                <Stack spacing={2}>
                    <Typography level="h4" component="h1" style={{ textAlign: "center" }}>
                        <b>Entrada</b>
                    </Typography>
                    <div style={{ textAlign: "center" }}>
                        {!logando && erro === "" && <div>
                            <Typography level="body2">Informe os dados para continuar</Typography>
                        </div>}
                        {logando && erro === "" && <div>
                            <Typography level="body2">Autenticando...</Typography>
                        </div>}

                        {erro !== "" && <div>
                            <Typography level="body2" style={{ color: "#c20000" }}>{erro}</Typography>
                        </div>}
                    </div>
                    <Input
                        // html input attribute
                        name="email"
                        type="email"
                        placeholder="digite seu usuário ou email..."
                        // pass down to FormLabel as children
                        value={email}
                        disabled={logando}
                        onChange={update}
                        label="Usuário ou Email"
                    />
                    <Input
                        name="password"
                        type="password"
                        value={senha}
                        disabled={logando}
                        onChange={update}
                        placeholder="digite sua senha..."
                        label="Password"
                    />
                    <Button sx={{ mt: 1 /* margin top */ }} onClick={() => logar()}
                        disabled={logando}>Log in</Button>

                </Stack>
            </Sheet>
        </main>
    </CssVarsProvider>
}

export default Login